import { computed } from 'vue'
import { useAppearanceStore } from '@/features/appearance/store'
import { resolveAppearance } from '@/features/appearance/resolveAppearance'

export function useConversationAppearance() {
  const store = useAppearanceStore()
  const resolved = computed(() => resolveAppearance(store.saved))
  return {
    fontFamily: computed(() => resolved.value.fontFamily),
    appearanceStyles: computed(() => resolved.value.appearanceStyles),
  }
}
